import {GridConfiguration, GridRequest} from "../../shared/grid/grid.model";
export class BillingRequestModel extends GridRequest {
  year: number;
  month: number;
}

export class BillingGridConfiguration extends GridConfiguration {

  constructor() {
    super();
    this.columns = [
      {
        dataField: 'venue',
        caption: 'Venue'
      },
      {
        dataField: 'invoiceNumber',
        caption: 'Invoice Number'
      },
      {
        dataField: 'covers',
        caption: 'Covers'
      },
      {
        dataField: 'rates',
        caption: 'Rates'
      },
      {
        dataField: 'amount',
        caption: 'Invoice',
        alignment: 'left',
        format: function (options) {
          if (options && options !== 0) {
            const result = Math.round(parseFloat(options) * 100) / 100;
            return result > 0 ? '£ ' + result.toFixed(2) : '£ 0.00';
          }
          return '£ 0.00';
        }
      }, {
        dataField: 'vat',
        caption: 'VAT',
        alignment: 'left',
        format: function (options) {
          if (options && options !== 0) {
            const result = Math.round(parseFloat(options) * 100) / 100;
            return result > 0 ? '£ ' + result.toFixed(2) : '£ 0.00';
          }
          return '£ 0.00';
        }
      },
      {
        dataField: 'total',
        caption: 'Total',
        alignment: 'left',
        format: function (options) {
          if (options && options !== 0) {
            const result = Math.round(parseFloat(options) * 100) / 100;
            return result > 0 ? '£ ' + result.toFixed(2) : '£ 0.00';
          }
          return '£ 0.00';
        }
      }


    ];

    this.summary =
      {
        totalItems: [{
          column: "total",
          summaryType: "sum",
          customizeText: function (data) {
            return 'Total: £ ' + (Math.round(parseFloat(data.value) * 100) / 100).toFixed(2);
          }
        }]
      }

    this.remoteOperations = {
      filtering: false,
      sorting: false,
      paging: false,
      grouping: false,
      summary: false
    };

    this.selection = false;
    this.columnAutoWidth = true;
    this.sorting = {mode: 'single'};
  }


  mapGridRequest(gridRequest: GridRequest, loadOptions: any) {
    super.mapGridRequest(gridRequest, loadOptions);
  }
}




// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/venues/venue-billing/venue-billing.model.ts